import React, { useEffect } from 'react';
import {
  Paper,
  Typography,
  Grid,
  TextField,
  Autocomplete
} from '@mui/material';

/**
 * Customer Information Component for Credit Notes
 * 
 * @param {Object} props
 * @param {Object} props.creditNote - Credit note data with customer information
 * @param {Array} props.customers - List of available customers
 * @param {Object} props.controlStyle - Style object for form controls
 * @param {Function} props.onCustomerChange - Function to handle customer selection
 */
const CustomerInformation = ({
  creditNote,
  customers,
  controlStyle,
  onCustomerChange
}) => {
  // Log when creditNote changes to track data flow
  useEffect(() => {
    console.log('CustomerInformation: creditNote changed', creditNote);
    if (creditNote && creditNote.customer) {
      console.log('CustomerInformation: customer data received', creditNote.customer);
    }
  }, [creditNote]);
  // Create a safe customer object to prevent null reference errors
  const customer = creditNote.customer || {};
  
  // Check if we have any customer data to display
  const hasCustomerData = customer && (
    customer.customerName || 
    customer.vat || 
    customer.customerPhone || 
    customer.customerAddress
  );
  
  return (
    <Paper 
      elevation={0} 
      sx={{ 
        p: 0.5, 
        mb: 0.5, 
        borderRadius: '4px',
        boxShadow: 'none',
        border: 'none',
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0.02)',
        },
      }}
    >
      <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 0.5, fontSize: '0.875rem' }}>
        Customer Information
      </Typography>
      <Grid container spacing={0.5}>
        {hasCustomerData ? (
          <>
            <Grid item xs={12}>
              <TextField
                label="Customer Name"
                value={customer.customerName || ''}
                InputProps={{
                  readOnly: true,
                }}
                fullWidth
                margin="dense"
                size="small"
                required
                sx={controlStyle}
              />
            </Grid>
            <Grid item xs={12}>
              {customer.vat ? (
                <TextField
                  label="VAT Number"
                  value={customer.vat || ''}
                  fullWidth
                  margin="dense"
                  size="small"
                  InputProps={{
                    readOnly: true,
                  }}
                  sx={controlStyle}
                />
              ) : (
                <TextField
                  label="Phone Number"
                  value={customer.customerPhone || ''}
                  fullWidth
                  margin="dense"
                  size="small"
                  InputProps={{
                    readOnly: true,
                  }}
                  sx={controlStyle}
                />
              )}
            </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Address"
                  value={customer.customerAddress || ''}
                  fullWidth
                  multiline
                  rows={2.5}
                  margin="dense"
                  size="small"
                  InputProps={{
                    readOnly: true,
                  }}
                  sx={{
                    ...controlStyle,
                    '& .MuiOutlinedInput-root': {
                      minHeight: 70,
                      borderRadius: 0
                    }
                  }}
                />
              </Grid>
          </>
        ) : (
          <Grid item xs={12}>
            <Typography variant="body2" color="text.secondary">
              Select an invoice to display customer information
            </Typography>
          </Grid>
        )}
      </Grid>
    </Paper>
  );
};

export default CustomerInformation;
